import { render, staticRenderFns } from "./BaseToolbar.vue?vue&type=template&id=516058d1"
import script from "./BaseToolbar.vue?vue&type=script&lang=js"
export * from "./BaseToolbar.vue?vue&type=script&lang=js"
import style0 from "./BaseToolbar.vue?vue&type=style&index=0&id=516058d1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports